<template>
  <div id="app" style="overflow-x: hidden">
    <!-- banner -->

    <header class="app_header">
      <div class="app_header_menuList">
        <img
          src="./assets/img/logo_home.png"
          style="margin-top: 10px; height: 44px"
        />
        <div
          v-for="menuLists in menuList"
          :key="menuLists.id"
          class="item"
          :class="selectMenuItemPath == menuLists.id ? 'actived' : ''"
          @click="toPath(menuLists)"
        >
          <span class="appLabel">{{ menuLists.label }}</span>
        </div>
      </div>
      <div class="museum-3D">
        <a
          style="color: #fff"
          target="_blank"
          href="http://fzwqg.720kk.cn/"
          >网上展厅</a
        >
      </div>
    </header>
    <div style="height: 70px"></div>
    <div class="commonBanner" v-if="selectMenuItemPath != 15">
      <img
        :src="
          oneMenuInfo && oneMenuInfo.menuBanner
            ? ips + oneMenuInfo.menuBanner
            : ''
        "
        alt
        height="509"
        width="100%"
        style="object-fit: cover"
      />
    </div>
    <div
      class="banner_scroll"
      v-if="selectMenuItemPath == 15"
      @mouseover="mouseOver1"
      @mouseleave="mouseLeave1"
    >
      <ul v-if="banner_imgArr && banner_imgArr.length > 0">
        <!-- .slice(0, 2) -->
        <li
          v-for="(banner_imgArrs, index1) in banner_imgArr"
          class="banner_scroll_item"
          :key="index1"
          :class="banner_index == index1 ? 'actived_li' : 'default_li'"
        >
          <img
            v-show="banner_index == index1"
            :src="
              banner_imgArrs && banner_imgArrs.imgUrl
                ? ips + banner_imgArrs.imgUrl
                : ''
            "
            alt=""
            height="894"
          />
        </li>
      </ul>
    </div>

    <router-view />
    <footer class="footer_style">
      <div class="footer_left">
        <div>{{ $t("sponsoredByHuaiMuseum") }} | CopyRight 2023-2024</div>
        <div>闽ICP备17000382号</div>
        <img src="./assets/img/institution.png" alt="" width="48" height="59" />
      </div>
      <div class="footer_right">
        <ul
          v-for="menuLists in menuList"
          :key="menuLists.id"
          :style="{
            display: menuLists.label !== '首页' ? 'inline-block' : 'none',
          }"
        >
          <li class="li_first">
            <div @click="idSave(menuLists)">
              {{ isZh ? menuLists.label : menuLists.menuEnName }}
            </div>
          </li>
          <li v-for="childItem in menuLists.children" :key="childItem.id">
            <div @click="idSave1(childItem, menuLists)">
              {{ isZh ? childItem.label : childItem.menuEnName }}
            </div>
          </li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  menuTreeApi,
  menuListApi,
  getOneMenuInfo, //获取一级菜单信息
} from "./assets/js/api.js";
import { getBanner, getHomeBanner } from "./assets/js/commonFun.js";
export default {
  name: "App",
  data() {
    return {
      isActive: false,
      timer: null,
      selectedValue: 1,
      selectMenuItemPath: "",
      menuList: [],
      isZh: true,
      name: "home",
      ips: "",
      oneMenuInfo: null,
      banner_imgArr: [] /* banner图 */,
      banner_index: 0,
      time_banner: null,
    };
  },
  created() {
    this.getIp();
  },
  async mounted() {
    await this.getBanner();
    let languageSet = localStorage.getItem("languageSet") || "zh";
    if (languageSet === "zh") {
      this.isZh = true;
    } else {
      this.isZh = false;
    }
    this.getMenuTree();
  },
  beforeDestroy() {
    clearInterval(this.time_banner);
    this.time_banner = null;
  },
  watch: {
    $route: {
      handler(route) {
        this.name = route.name;
        this.selectMenuItemPath = route.params.id ? route.params.id : "15";
        if (route.params.id) {
          this.getOneMenuInfoFun(route.params.id);
        }
      },
      immediate: true,
    },
  },
  methods: {
    /* 获取导航栏 */
    async getMenuTree() {
      let menuTreeApiData = await menuTreeApi();
      if (menuTreeApiData.code == 200) {
        this.menuList = menuTreeApiData.data || [];
        sessionStorage.setItem(
          "menuList",
          JSON.stringify(menuTreeApiData.data)
        );
      }
    },
    /* 获取banner图 */
    getBanner() {
      getHomeBanner((data) => {
        let banner = data;
        let arr = [];
        if (banner && banner.length > 0) {
          banner.forEach((item) => {
            if (item.bannerType === "0") {
              arr.push(item);
            }
          });
        }
        this.banner_imgArr = arr;
      });
    },
    /* 导航栏跳转 */
    toPath(item) {
      if (item.menuEnName == "home" || item.menuEnName == "HOME") {
        this.$router.push({ path: "/" });
      } else {
		if (item.menuEnName == "COLLECTION" || item.menuEnName == "collection") {
        window.open("http://www.wenbobanglm.com:9600/");
		} else {
			sessionStorage.removeItem("ActiveObj");
			sessionStorage.removeItem("detail_obj");
			this.$router.push({ path: "/common/" + item.id });
		}
      }
    },
    /* 设置请求头 */
    getIp() {
      // this.ips = "http://8.140.52.241:8400";
      this.ips = "http://112.51.251.245:8300";
      sessionStorage.setItem("ips", this.ips);
    },
    /* banner图鼠标移入移出 */
    mouseOver1() {
      clearInterval(this.time_banner);
      this.time_banner = null;
    },
    mouseLeave1() {
      clearInterval(this.time_banner);
      this.time_banner = setInterval(() => {
        if (this.banner_index >= this.banner_imgArr.length - 1) {
          this.banner_index = 0;
        } else {
          this.banner_index = this.banner_index + 1;
        }
      }, 5000);
    },
    async getOneMenuInfoFun(id) {
      let { data } = await getOneMenuInfo(id);
      this.oneMenuInfo = data;
    },

    idSave(item) {
      sessionStorage.removeItem("detail_obj");
      if (item.menuEnName == "home") {
        this.$router.push({ path: "/" });
      } else {
        sessionStorage.setItem(
          "ActiveObj",
          JSON.stringify({
            path: item.children[0].modulesType || "error",
            active: item.children[0].id,
            activeName: [item.children[0].label, item.children[0].menuEnName],
          })
        );
        this.$store.commit({
          type: "SECOND_ID",
          second_id: item.children[0].id,
        });
        this.$router.push({
          path: "/common/" + item.id + "/" + item.children[0].modulesType,
        });
      }
    },
    idSave1(item, item1) {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: item.modulesType || "error",
          active: item.id,
          activeName: [item.label, item.menuEnName],
        })
      );
      this.$store.commit({ type: "SECOND_ID", second_id: item.id });
      this.$router.push({
        path: "/common/" + item1.id + "/" + item.modulesType,
      });
    },
  },
};
</script>

<style lang='scss'>
html {
  @media screen and (max-width: 1280px) {
    width: 1280px;
  }
  width: 100%;
}
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Microsoft YaHei";
  //   text-align: center;
  color: #000;
}
.app_header {
  height: 70px;
  background: #a99279;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 99;
  .app_header_menuList {
    width: 1260px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .item {
      color: #fff;
      line-height: 70px;
      cursor: pointer;
      font-size: 18px;
      height: 66px;
      &.actived {
        color: #fff7e4;
        border-bottom: 5px #fff7e4 solid;
      }
    }
  }
}
.museum-3D {
  // position: absolute;
  // right: 28px;
  font-size: 20px;
  padding-right: 12px;
  &:hover {
    cursor: pointer;
  }
}
.commonBanner {
  height: 509px;
}
.banner_scroll {
  max-height: 60vw;
  position: relative;
  width: 100%;
  ul {
    // padding-bottom: 47%;
    // position: relative;
    overflow: hidden;
    margin: 0;
    margin-left: -15px;
    li {
      list-style: none;
      width: 100%;
      height: calc(100vh - 70px);
      // position: relative;
      left: 0;
      top: 0;
      img {
        width: 100%;
        height: calc(100vh - 70px);
        object-fit: cover;
        object-position: center;
        display: block;
        margin-left: -10px;
      }
    }
    li.default_li {
      transform: scale(1, 1);
      opacity: 0;
      z-index: -1;
      // display: none;
      height: 0px;
      transition: opacity 1000ms linear 0s;
    }
    li.actived_li {
      transform: scale(1.05, 1.05);
      opacity: 1;
      z-index: 0;
      height: 100%;
      // display: block;
      transition: transform 5000ms linear 0s, opacity 1000ms linear 0s;
    }
  }
  .bannerMenuBack {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 68px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    .bannerMenu {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      .item {
        cursor: pointer;
        &:hover {
          color: #a09f9a;
        }
      }
      img {
        margin: 0 30px;
      }
    }
  }
}
.footer_style {
  background: #41403b;
  // height: 218px;
  color: rgba(223, 223, 223, 1);
  // padding: 30px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .footer_left {
    padding-right: 42px;
    border-right: 1px solid rgba(173, 171, 167, 1);
    height: 218px;
    text-align: center;
    div {
      margin-bottom: 18px;
    }
    div + div {
      margin-bottom: 54px;
    }
  }
  .footer_right {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    ul li.li_first {
      color: #9c9c9c;
      font-size: 16px;
    }
    ul {
      margin: 0;
    }
    ul li {
      list-style: none;
      margin-bottom: 18px;
      font-size: 14px;
      font-weight: bold;

      text-align: left;
      cursor: pointer;
      a {
        color: #dfdfdf;
        text-decoration: none;
      }
      &:hover {
        a {
          color: #9b7c66;
        }
      }
    }
    .footer_selected {
      margin-left: 30px;
      .el-input {
        width: 264px;
        height: 40px;
        input {
          border-radius: 0;
          background: rgba(130, 107, 97, 1);
          color: #fff;
          border: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue